import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonWithLoadingState } from "../../../../../common/components/button-with-loading-state/ButtonWithLoadingState";
import { CodePinFields } from "../../../../../common/components/code-pin-fields/CodePinFields";
import styles from "./enterPinContent.module.scss";

export interface EnterPinContentProps {
	onPinSubmitted: (pin: string) => void;
	onForgotPinPressed: () => void;
	submitButtonText?: string;
}

export const EnterPinContent: React.FC<EnterPinContentProps> = ({ onPinSubmitted, onForgotPinPressed, submitButtonText }) => {
	const { t } = useTranslation();
	const [pin, setPin] = useState("");

	return (
		<div className={styles.content}>
			<CodePinFields numberOfFields={4} value={pin} onChange={setPin} obscureText autoFocus />

			<button type="button" className={styles.forgotPin} onClick={onForgotPinPressed}>
				{t("pin.forgotPin")}
			</button>

			<div className={styles.btnWrapper}>
				<ButtonWithLoadingState buttonText={submitButtonText ?? t("common.actions.continueKey")} buttonPressed={pin.length === 4 ? () => onPinSubmitted(pin) : null} />
			</div>
		</div>
	);
};
